import gql from 'graphql-tag';

const pricingsQuery = gql`
    query pricings($listingIds: [String]) {
        getPricings(listingIds: $listingIds) {
            listingId
            price: priceSummary {
                value: amount
                currency
            }
        }
    }
`;

export default pricingsQuery;
